import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ChipView extends React.PureComponent {
    render() {
        const chipView = (
            <div className={styles.content_list}>
                <div className={styles.top_40}>
                    <Chip id="287315" type="recommend" title="图集年份1" groupName="图集数据">
                        <div className={styles.chip_item} />
                    </Chip>
                    <Chip id="287316" type="recommend" title="图集年份2" groupName="图集数据">
                        <div className={styles.chip_item} />
                    </Chip>
                    <Chip id="287317" type="recommend" title="图集年份3" groupName="图集数据">
                        <div className={styles.chip_item} />
                    </Chip>
                    <Chip id="287318" type="recommend" title="图集年份4" groupName="图集数据">
                        <div className={styles.chip_item} />
                    </Chip>
                    <Chip id="287319" type="recommend" title="图集年份5" groupName="图集数据">
                        <div className={styles.chip_item} />
                    </Chip>
                    <Chip id="287320" type="recommend" title="图集年份6" groupName="图集数据">
                        <div className={styles.chip_item} />
                    </Chip>
                    <Chip id="287321" type="recommend" title="图集年份7" groupName="图集数据">
                        <div className={styles.chip_item} />
                    </Chip>
                </div>
            </div>
        );

        return ReactDOM.createPortal(chipView, document.body);
    }
}

export default errorBoundary(ChipView);
